import styles from '../styles/Dashboard.module.css';
import { useRouter } from 'next/router';
import { useState, useEffect, useContext } from 'react';
import { UserContext } from '../lib/context';
import { mp } from '../lib/mixpanel';

export default function NavbarMobile() {
  const router = useRouter();
  const { user } = useContext(UserContext);

  return (
    <div className={`${styles['navbar-dashboard-container']} red`}>
      {!router.pathname.includes('dashboard') && <Linkk1 router={router} />}
      {!router.pathname.includes('consultations') && <Linkk2 router={router} />}
      {!router.pathname.includes('prescriptions') && <Linkk3 router={router} />}
      {!router.pathname.includes('profile') && <Linkk4 router={router} />}
      {!router.pathname.includes('billing') && <Linkk5 router={router} />}
      {!router.pathname.includes('shipping') && <Linkk6 router={router} />}
      {!router.pathname.includes('chat') && <Linkk7 router={router} />}
      {!router.pathname.includes('refer') && (
        <Linkk8 router={router} user={user} />
      )}
    </div>
  );
}

function Linkk1({ router }) {
  return (
    <div
      onClick={() => router.push('/dashboard')}
      className={`${styles['mobile-link-item-container']} red`}
    >
      <div className={`${styles['mobile-link-item-container-left']} red`}>
        <div className={`${styles['mobile-link-item-container-logo']} red`}>
          <svg
            // class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
            ></path>
          </svg>
        </div>
      </div>
      <div className={`${styles['mobile-link-item-container-right']} red`}>
        <div className={`${styles['mobile-link-item-container-title']} red`}>
          Dashboard
        </div>
        <div className={`${styles['mobile-link-item-container-sub']} red`}>
          Home page
        </div>
      </div>
    </div>
  );
}

function Linkk2({ router }) {
  return (
    <div
      onClick={() => router.push('/consultations')}
      className={`${styles['mobile-link-item-container']} red`}
    >
      <div className={`${styles['mobile-link-item-container-left']} red`}>
        <div className={`${styles['mobile-link-item-container-logo']} red`}>
          <svg
            // class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
            ></path>
          </svg>
        </div>
      </div>
      <div className={`${styles['mobile-link-item-container-right']} red`}>
        <div className={`${styles['mobile-link-item-container-title']} red`}>
          Consultations
        </div>
        <div className={`${styles['mobile-link-item-container-sub']} red`}>
          Manage your consultations
        </div>
      </div>
    </div>
  );
}

function Linkk3({ router }) {
  return (
    <div
      onClick={() => router.push('/prescriptions')}
      className={`${styles['mobile-link-item-container']} red`}
    >
      <div className={`${styles['mobile-link-item-container-left']} red`}>
        <div className={`${styles['mobile-link-item-container-logo']} red`}>
          <svg
            // class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
            ></path>
          </svg>
        </div>
      </div>
      <div className={`${styles['mobile-link-item-container-right']} red`}>
        <div className={`${styles['mobile-link-item-container-title']} red`}>
          Prescriptions
        </div>
        <div className={`${styles['mobile-link-item-container-sub']} red`}>
          Manage your consultations
        </div>
      </div>
    </div>
  );
}

function Linkk4({ router }) {
  return (
    <div
      onClick={() => router.push('/profile')}
      className={`${styles['mobile-link-item-container']} red`}
    >
      <div className={`${styles['mobile-link-item-container-left']} red`}>
        <div className={`${styles['mobile-link-item-container-logo']} red`}>
          {/* <svg
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
            ></path>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            ></path>
          </svg> */}
          <svg
            // class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"
            ></path>
          </svg>
        </div>
      </div>
      <div className={`${styles['mobile-link-item-container-right']} red`}>
        <div className={`${styles['mobile-link-item-container-title']} red`}>
          Profile
        </div>
        <div className={`${styles['mobile-link-item-container-sub']} red`}>
          Account settings
        </div>
      </div>
    </div>
  );
}

function Linkk5({ router }) {
  return (
    <div
      onClick={() => router.push('/billing')}
      className={`${styles['mobile-link-item-container']} red`}
    >
      <div className={`${styles['mobile-link-item-container-left']} red`}>
        <div className={`${styles['mobile-link-item-container-logo']} red`}>
          <svg
            // class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
            ></path>
          </svg>
        </div>
      </div>
      <div className={`${styles['mobile-link-item-container-right']} red`}>
        <div className={`${styles['mobile-link-item-container-title']} red`}>
          Billing Info
        </div>
        <div className={`${styles['mobile-link-item-container-sub']} red`}>
          Manage how you pay
        </div>
      </div>
    </div>
  );
}

function Linkk6({ router }) {
  return (
    <div
      onClick={() => router.push('/shipping')}
      className={`${styles['mobile-link-item-container']} red`}
    >
      <div className={`${styles['mobile-link-item-container-left']} red`}>
        <div className={`${styles['mobile-link-item-container-logo']} red`}>
          <svg
            // class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
            ></path>
          </svg>
        </div>
      </div>
      <div className={`${styles['mobile-link-item-container-right']} red`}>
        <div className={`${styles['mobile-link-item-container-title']} red`}>
          Shipping Info
        </div>
        <div className={`${styles['mobile-link-item-container-sub']} red`}>
          Where you receive packages
        </div>
      </div>
    </div>
  );
}

function Linkk7({ router }) {
  return (
    <div
      onClick={() => router.push('/chat')}
      className={`${styles['mobile-link-item-container']} red`}
    >
      <div className={`${styles['mobile-link-item-container-left']} red`}>
        <div className={`${styles['mobile-link-item-container-logo']} red`}>
          <svg
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
            ></path>
          </svg>
        </div>
      </div>
      <div className={`${styles['mobile-link-item-container-right']} red`}>
        <div className={`${styles['mobile-link-item-container-title']} red`}>
          Chat
        </div>
        <div className={`${styles['mobile-link-item-container-sub']} red`}>
          Communicate with our care team
        </div>
      </div>
    </div>
  );
}

function Linkk8({ router, user }) {
  const clickRefer = () => {
    mp.track('referral_click_cta', {
      userID: user.uid,
      name: 'friends dashboard link mobile',
    });
    router.push('/refer');
  };

  return (
    <div
      onClick={clickRefer}
      className={`${styles['mobile-link-item-container']} red`}
    >
      <div className={`${styles['mobile-link-item-container-left']} red`}>
        <div className={`${styles['mobile-link-item-container-logo']} red`}>
          <svg
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
            ></path>
          </svg>
        </div>
      </div>
      <div className={`${styles['mobile-link-item-container-right']} red`}>
        <div className={`${styles['mobile-link-item-container-title']} red`}>
          Friends
        </div>
        <div className={`${styles['mobile-link-item-container-sub']} red`}>
          Invite friends, earn $250
        </div>
      </div>
    </div>
  );
}
